import React, { useRef } from "react";
import { Container, ContentContainer, ExtraContent, ExtraTitle, Header, Icon, IconCloseBtn, Manager, ManagerImg, ManagerTxt, MemberImg, MemberName, Text, MemberTitle, ContentGridContainer, SpouseImg, SpouseContainer, ChildContainer, Link, } from "./MemberModal.styles";
import CloseIcon from "../assets/FileUpload/close.svg";
import Arrow from "../assets/MemberModal/Arrow.svg";
import PinImg from "../assets/MemberModal/pin.svg";
import CalImg from "../assets/MemberModal/calendar.svg";
import CakeImg from "../assets/MemberModal/cake.svg";
import Avatar from "../assets/Images/Avatar.svg";
var today = new Date();
var daysInYear = 365;
var daysInMonth = 30;
function dateToStr(date, options) {
    var dateStrOptions = (options === null || options === void 0 ? void 0 : options.dateStrOptions) || {
        month: "short",
        day: "numeric",
        year: "numeric",
    };
    var dayStr = date.toLocaleDateString(undefined, dateStrOptions);
    // if there is options for displaying time since
    if (options && (options.days || options.years || options.months)) {
        // calculate time till today
        var timeSince = today.getTime() - date.getTime();
        var timeSinceStr = new Array();
        // divide the time since by milliseconds in a day
        var daySince = Math.floor(timeSince / (1000 * 3600 * 24));
        if (options.years) {
            var yearSince = Math.floor(daySince / daysInYear);
            if (yearSince > 0)
                timeSinceStr.push(yearSince + " year" + (yearSince > 1 ? "s" : ""));
            daySince %= daysInYear;
        }
        if (options.months) {
            var monthSince = Math.floor(daySince / daysInYear);
            if (monthSince > 0)
                timeSinceStr.push(monthSince + " month" + (monthSince > 1 ? "s" : ""));
            daySince %= daysInMonth;
        }
        if (options.days) {
            if (daySince > 0)
                timeSinceStr.push(daySince + " day" + (daySince > 1 ? "s" : ""));
        }
        // add optional time since to the dayString
        dayStr += " (" + timeSinceStr.join(", ") + (options.suffix || "") + ")";
    }
    return dayStr;
}
export var MemberModal = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, memberInfo = _a.memberInfo, token = _a.token, uncloseable = _a.uncloseable;
    var member = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.member;
    var manager = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.manager;
    var spouse = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.spouse;
    var directReports = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.directReports;
    var children = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.children;
    var pets = memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.pets;
    var modal = useRef(null);
    var getDirectReports = function () {
        var dirArr = [];
        if (directReports) {
            for (var i = 0; i < directReports.length && i < 4; i++) {
                var person = directReports[i];
                dirArr.push(person.firstName + " " + person.lastName);
            }
            var remain = directReports.length - dirArr.length;
            return (React.createElement(Text, null,
                dirArr.join(", ") + (remain > 0 ? " and " : ""),
                remain > 0 ? (React.createElement(Link, { href: "#LinkToTeamPage" },
                    remain,
                    " more...")) : null));
        }
    };
    //generic click handler for the document
    var handleClick = function (event) {
        if (!uncloseable) {
            if (modal.current) {
                //check if the drop down is open and not the target
                if (event.target &&
                    !modal.current.contains(event.target)) {
                    //close modal
                    handleClose(false);
                }
            }
        }
    };
    React.useEffect(function () {
        document.addEventListener("click", handleClick);
        return function () { return document.removeEventListener("click", handleClick); };
    }, []);
    return (React.createElement(React.Fragment, null, open && (React.createElement(Container, { ref: modal, uncloseable: uncloseable },
        React.createElement(Header, null,
            !uncloseable && (React.createElement(IconCloseBtn, { src: CloseIcon, onClick: function () { return handleClose(false); } })),
            manager && (React.createElement(React.Fragment, null,
                React.createElement(Manager, null,
                    React.createElement(ManagerImg, { src: manager.id
                            ? process.env.REACT_APP_API_URL + "/members/" + manager.id + "/photo?authorization=" + token
                            : Avatar }),
                    React.createElement(ManagerTxt, null, manager.firstName + " " + manager.lastName)),
                React.createElement(Icon, { src: Arrow }))),
            member && (React.createElement(Link, { href: "/admin/members/" + member.memberId },
                React.createElement(MemberImg, { src: process.env.REACT_APP_API_URL + "/members/" + member.memberId + "/photo?authorization=" + token })))),
        React.createElement(ContentContainer, null,
            member && (React.createElement(Link, { href: "/admin/members/" + member.memberId },
                React.createElement(MemberName, null, member.firstName + " " + member.lastName))),
            member && member.title && (React.createElement(MemberTitle, null, member.title)),
            member && member.team && React.createElement(Text, null, member.team)),
        React.createElement(ContentGridContainer, null,
            member && member.location && (React.createElement(React.Fragment, null,
                React.createElement(Icon, { src: PinImg }),
                " ",
                React.createElement(Text, null, member.location))),
            member && member.hireDate && (React.createElement(React.Fragment, null,
                React.createElement(Icon, { src: CalImg }),
                " ",
                React.createElement(Text, null, dateToStr(member.hireDate, {
                    years: true,
                    days: true,
                })))),
            member && member.birthDate && (React.createElement(React.Fragment, null,
                React.createElement(Icon, { src: CakeImg }),
                " ",
                React.createElement(Text, null, dateToStr(member.birthDate, {
                    years: true,
                    suffix: " old",
                }))))),
        React.createElement(ContentContainer, null,
            React.createElement(MemberTitle, null, "Direct Reports"),
            getDirectReports()),
        spouse !== undefined && ( // Spouse section
        React.createElement(ExtraContent, null,
            React.createElement(ExtraTitle, null, "Spouse"),
            React.createElement(SpouseContainer, null,
                React.createElement(SpouseImg, { src: spouse.image }),
                React.createElement(MemberTitle, null, spouse.firstName + " " + spouse.lastName)),
            spouse.marriedDate && (React.createElement(Text, null,
                "Married: ",
                dateToStr(spouse.marriedDate))),
            spouse.birthDate && (React.createElement(Text, null,
                "Birthday:",
                " ",
                dateToStr(spouse.birthDate, {
                    dateStrOptions: {
                        month: "short",
                        day: "numeric",
                    },
                }))),
            spouse.email && (React.createElement(Text, null,
                React.createElement(Link, { href: "mailto:" + spouse.email }, spouse.email))),
            spouse.phone && (React.createElement(Text, null,
                React.createElement(Link, { href: "tel:" + spouse.phone }, spouse.phone))))),
        children !== undefined && ( // Children section
        React.createElement(ExtraContent, null,
            React.createElement(ExtraTitle, null, "Children"),
            children.map(function (child) { return (React.createElement(ChildContainer, { key: child.id },
                React.createElement(MemberTitle, null,
                    child.firstName,
                    " ",
                    child.gender && "(" + child.gender + ")"),
                child.birthDate && (React.createElement(Text, null, dateToStr(child.birthDate, {
                    years: true,
                    suffix: " old",
                }))))); }))),
        pets !== undefined && ( // Pets section
        React.createElement(ExtraContent, null,
            React.createElement(ExtraTitle, null, "Pets"),
            pets.map(function (child) { return (React.createElement(ChildContainer, { key: child.id },
                React.createElement(MemberTitle, null, child.firstName),
                React.createElement(Text, null, child.species))); })))))));
};
//# sourceMappingURL=MemberModal.js.map